<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('attributes')">
            <app-default-button
                :title="$fieldTitle('add', 'attribute', true)"
                v-if="$can('create_attribute')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="attribute-table"
            :options="options"
            @action="triggerActions"
        />

        <app-attribute-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('attribute-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import AttributeMixins from "../../../Mixins/AttributeMixins";

export default {
    name  : "AppAttribute",
    mixins: [HelperMixin, AttributeMixins],
    props : {
        employeeId: {
            type: String,
        },
    },
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/attribute/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>